import {
  AppBar,
  Container,
  Toolbar,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react';
import CustomizedMenus from './menuButton';
import { ReactComponent as Logo } from '../../assets/images/Trustchat1.svg';

const useStyles = makeStyles((theme) => ({
  main__container: {
    padding: '0 24px',
    boxSizing: 'border-box',

    maxWidth: '100% !important',
    '& .MuiToolbar-root': {
      paddingLeft: '0',
      paddingRight: '0',
      minHeight: '64px !important',
      display: 'flex',
      alignItems: 'center', // Center items vertically
    },
  },
  main__bar: {
    backgroundColor: '#fff',
    boxShadow: 'none',
    width: '100%',
    overflow: 'hidden',
  },
  main__logo: {

    width: 'auto',
  },
  grow: {
    flexGrow: 1,
  },
  toolbarContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center', // This centers both items vertically
    width: '100%',
    height: '100%',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    flex: '0 0 auto',
  },
  menuContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
  },
}));

export default function PrimarySearchAppBar() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
    loggedin: false,
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('userData'));
    const userdata = user?.decoded;
    if (typeof userdata !== 'undefined' && Date.now() / 1000 > userdata?.exp) {
      setState({
        ...state,
        loggedin: false,
      });
    } else if (
      typeof userdata !== 'undefined' &&
      Date.now() / 1000 < userdata?.exp
    ) {
      setState({
        ...state,
        loggedin: true,
      });
    }
  }, []);

  return (
    <>
      <AppBar position="static" className={classes.main__bar}>
        <Container className={classes.main__container}>
          <Toolbar>
            <div className={classes.toolbarContent}>
              <div className={classes.logoContainer}>
                <Logo className={classes.main__logo} />
              </div>
              <div className={classes.menuContainer}>
                <CustomizedMenus />
              </div>
            </div>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
}